import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'annoying-banner',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content)
    }, [
      _createVNode(BaseIcon, {
        type: "attention-thin",
        class: _normalizeClass(_ctx.$style.icon)
      }, null, 8, ["class"]),
      _createElementVNode("div", null, [
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.$style.caption)
        }, [
          _renderSlot(_ctx.$slots, "caption")
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.description)
        }, [
          _renderSlot(_ctx.$slots, "description")
        ], 2)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.action)
    }, [
      _renderSlot(_ctx.$slots, "action")
    ], 2)
  ], 2))
}
}

})